import { CourseSet } from "../../types/requirement.response";
import { getBroadKind } from "../../utils/requirementResponseUtils";
import { ReqDetailBaseProps } from "./types";
import CourseSetRows from "./CourseSetRows";
import SuggestedCourseRows from "../requirement-section/SuggestedCourseRows";

export default function ListReqDetail({
    programInfo,
    requirement,
    coursesMap,
    isSliceLoaded,
    handleAddCourse,
    handleDeleteCourse,
    handleFavoriteCourse,
    optimisticFavorites,
    userCourses,
    hideUnavailable,
}: ReqDetailBaseProps) {
    const rootNode = requirement.rootNode as CourseSet;
    const broadKind = getBroadKind(requirement);

    return (
        <>
            {broadKind === "approval" && (
                <tr>
                    <td colSpan={4} className="py-4">
                        <div className="flex items-start gap-2 px-3 py-2.5 bg-amber-50 border border-amber-200 rounded-md text-sm text-amber-800">
                            <span className="mt-0.5 shrink-0">⚠️</span>
                            <span>This requirement covers a broad range of courses. We're unable to display all eligible courses or automatically verify completion—-please review it manually.</span>
                        </div>
                    </td>
                </tr>
            )}
            <CourseSetRows
                courseSet={rootNode}
                programInfo={programInfo}
                coursesMap={coursesMap}
                isSliceLoaded={isSliceLoaded}
                requirementId={requirement.info.id}
                handleAddCourse={handleAddCourse}
                handleDeleteCourse={handleDeleteCourse}
                handleFavoriteCourse={handleFavoriteCourse}
                optimisticFavorites={optimisticFavorites}
                userCourses={userCourses}
                hideUnavailable={hideUnavailable}
                emptyMessage={broadKind === "intensional"
                    ? "Courses you take that match this requirement will show up here."
                    : undefined}
            />
            {broadKind === "intensional" && (
                <SuggestedCourseRows
                    programId={programInfo.id}
                    requirement={requirement}
                    handleAddCourse={handleAddCourse}
                    handleDeleteCourse={handleDeleteCourse}
                    handleFavoriteCourse={handleFavoriteCourse}
                    optimisticFavorites={optimisticFavorites}
                    userCourses={userCourses}
                    initialLimit={10}
                />
            )}
        </>
    );
}
